export default __webpack_public_path__ + "static/Face4-a53fbabfa8c0ee38eebd1f48718062a5.jpg";